import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// Features Section Component - Three powerful ways to transform jewelry
const FeaturesSection = () => {
  const { isAuthenticated, login } = useAuth();

  // Handle CTA button click
  const handleTryFeatures = () => {
    if (isAuthenticated()) {
      // Already logged in - scroll to top or navigate to main page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Not logged in - trigger login
      login();
    }
  };

  // Features data
  const features = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#6A28D7" opacity="0.1"/>
          {/* Robot head */}
          <rect x="16" y="14" width="16" height="18" rx="2" fill="#6A28D7"/>
          <circle cx="20" cy="20" r="2" fill="#3B82F6"/>
          <circle cx="28" cy="20" r="2" fill="#10B981"/>
          <rect x="18" y="26" width="12" height="2" rx="1" fill="#ffffff"/>
        </svg>
      ),
      title: 'AI Generated Models',
      description: 'Place your jewelry on stunning AI-generated human models. Choose from diverse models, poses, and settings that perfectly showcase your pieces.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#6A28D7" opacity="0.1"/>
          {/* Person silhouette */}
          <circle cx="24" cy="18" r="6" fill="#ffffff"/>
          <path d="M12 38c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#ffffff"/>
        </svg>
      ),
      title: 'Real Human Integration',
      description: 'Upload your own model photos and seamlessly integrate your jewelry onto real people. Perfect for brand consistency and authentic representation.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#6A28D7" opacity="0.1"/>
          {/* Abstract geometric shape */}
          <path d="M24 8L32 16L24 24L16 16L24 8Z" fill="#FBBF24"/>
          <path d="M32 16L40 24L32 32L24 24L32 16Z" fill="#F59E0B"/>
          <path d="M16 16L24 24L16 32L8 24L16 16Z" fill="#6A28D7"/>
          <circle cx="24" cy="24" r="4" fill="#EF4444"/>
        </svg>
      ),
      title: 'Aesthetic Backgrounds',
      description: 'Transform plain jewelry shots with beautiful, professional backgrounds. From luxury settings to minimalist designs - perfect for every brand aesthetic.'
    }
  ];

  return (
    <section className="features-section">
      <div className="features-section-container">
        <h2 className="features-section-title">Three Powerful Ways to Transform Your Jewelry</h2>
        
        <div className="features-cards-wrapper">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-cta-wrapper">
          <button className="features-cta-button" onClick={handleTryFeatures}>
            Try All Features Free
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;

